import glamorous from 'glamorous'

const BigButton = glamorous.button({
  height: 48,
  width: '100%',
  borderRadius: 3,
  fontSize: 18,
  lineHeight: 1,
  color: '#ffffff',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#99999a',
  border: 0,
  outline: 0,
  padding: 0,
  cursor: 'pointer'
})

export default BigButton



// WEBPACK FOOTER //
// ./src/components/settings/BigButton.js